import { APIClient } from "api/api_helper";
import { CRYOVIAL_LABEL_API } from "api/url_helper";
import { CurrentUser, GetUserData } from "common/service/CommonService";

const api = new APIClient();

export const SampleSeparationApiService = {
    // SELECT ALL SAMPLE SEPARATION 
    selectAll: (payload_data: any) => {
        const user = GetUserData() as CurrentUser;

        const periodVal = payload_data.period && payload_data.period !== "ALL" ? String(payload_data.period) : null;
        
        const parseArrayFilter = (val: any): string[] | null => {
            if (val === null || val === undefined) return null;
            if (Array.isArray(val)) {
                if (val.length === 0 || val.includes("ALL")) return null;
                return val.map(String);
            }
            if (val === "ALL") return null;
            return [String(val)];
        };

        const tpVal = parseArrayFilter(payload_data.timepoint);
        const aliVal = parseArrayFilter(payload_data.aliquot);

        const payload = {
            studyid: payload_data.studyid,
            period_number: periodVal,
            timepoint_number: tpVal,
            aliquot_number: aliVal,
            currentpage: payload_data.currentpage ?? null,
            pagesize: payload_data.pagesize ?? null,
            searchtext: payload_data.searchtext || null,
            status: payload_data.status || "A",
        };
        return api.create(CRYOVIAL_LABEL_API.CRYOVIAL_LABEL_API + "SelectAll", payload);
    },
    // UPDATE CRYOVIAL LABEL PRINT
    updateLabel: (payload_data: any) => {
        const user = GetUserData() as CurrentUser;
        const payload = {
            studyid: payload_data.studyid,
            sampleseparation: payload_data.sampleseparation || [],
            printby: user?.userid,
        };
        return api.create(CRYOVIAL_LABEL_API.CRYOVIAL_LABEL_API + "Update", payload);
    },
    // INSERT CRYOVIAL LABEL REPRINT HISTORY
    insertHistory: (payload_data: any) => {
        const user = GetUserData() as CurrentUser;
        const payload = {
            studyid: payload_data.studyid,
            printby: user?.userid,
            verifiedby: null,
            createdby: user?.userid,
            reasonforreprint: payload_data.reasonforreprint,
            additionalcomments: payload_data.additionalcomments,
            printcount: payload_data.printcount || 1,
            jsondata: payload_data.jsondata || [],
        };
        return api.create(sessionStorage.getItem("baseUrl") + "CryovialLabelHistory/Insert", payload);
    },
};